import { createFileRoute } from '@tanstack/react-router'

import { DashboardUpdatesPage } from '@/pages/dashboard/updates/page'

export const Route = createFileRoute('/_dashboard/updates')({
  component: DashboardUpdatesPage,
  validateSearch: (search) => {
    return {
      page: search?.page ? Number(search.page) : 1,
    }
  },
})
